// import { lazyImport } from '@/utils/lazyImport';

export const publicRoutes = [];

export default publicRoutes;
